import { ProcessSpecificationDTO } from 'support/types';

type Fields = ProcessSpecificationDTO['fields'];

export const revealPartyFields = (fields: Fields): Fields => {
  const result = [...fields];
  const index = result.findIndex((field) => field.path === 'parties');
  if (index !== -1 && result[index].is_hidden) {
    result[index] = { ...result[index], is_hidden: false };
  }
  return result;
};
